import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import notifications from "./modules/widgets/notifications";
import grids from "./modules/widgets/grids";
import modals from "./modules/widgets/modals";
import filterStatus from "./modules/widgets/filterStatus";
import routeGlobal from "./modules/widgets/routeGlobal";

import occurrence from "./modules/occurrenceModule";
import routes from "./modules/routesModule";
import captcha from "./modules/captchaModule";
import password from "./modules/passwordModule";
import account from "./modules/accountModule";
import user from "./modules/userModule";
import profiles from "./modules/profilesModule";
import origin from "./modules/originModule";
import cause from "./modules/causeModule";
import diagnoses from "./modules/diagnoses";
import resoluteness from "./modules/resoluteness";
import procedures from "./modules/procedures";
import docutor from "./modules/docutorModule";
import provenance from "./modules/provenanceModule";
import event from "./modules/eventModule";
import postoModule from "./modules/postoModule";
import logsModule from "./modules/logsModule";
import scheduleModule from "./modules/scheduleModule";
import healthcareModule from "./modules/healthcareModule";
import testModule from "./modules/testModule";
import vaccineModule from "./modules/vaccineModule";
import parameterization from "./modules/parameterizationModule";
import unitModule from "./modules/unitModule";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // WIDGETS
    notifications,
    grids,
    modals,
    filterStatus,
    routeGlobal,
    // MODULES
    event,
    logsModule,
    origin,
    provenance,
    procedures,
    docutor,
    postoModule,
    resoluteness,
    diagnoses,
    cause,
    routes,
    captcha,
    password,
    account,
    user,
    profiles,
    occurrence,
    scheduleModule,
    healthcareModule,
    testModule,
    vaccineModule,
    parameterization,
    unitModule,
  },
   plugins: [
    createPersistedState({
      key: 'vuex',
      paths: ['routeGlobal'], // persistindo apenas partes específicas dos módulos
    }),
  ],
});
